import api from './api';

export const getInvoices = (scope) => api.get('/invoices', { params: scope ? { scope } : {} });
export const getInvoice = (id) => api.get(`/invoices/${id}`);
export const getInvoiceData = (id) => api.get(`/invoices/${id}/data`);
// The invoice PDF is made by the server (print layout, services/invoice_pdf.py): read-only, nothing is sent or changed.
export const getInvoicePdf = (id, lang) => api.get(`/invoices/${id}/pdf`, { params: lang ? { lang } : {}, responseType: 'blob' });
export const getInvoiceByOrder = (orderId) => api.get(`/invoices/order/${orderId}`);
export const createInvoice = (data) => api.post('/invoices', data);
export const updateInvoice = (id, data) => api.put(`/invoices/${id}`, data);
export const deleteInvoice = (id) => api.delete(`/invoices/${id}`);
export const deleteAllTestInvoices = () => api.post('/invoices/test/delete-all');
